import React from 'react';

import { clsx } from 'clsx';

import styles from './Tag.scss';

type TagProps = React.ComponentPropsWithoutRef<'button'> & {
  isActive?: boolean;
};

export const Tag = React.forwardRef<HTMLButtonElement, TagProps>(
  ({ isActive, className, children, ...props }, ref) => (
    <button
      ref={ref}
      className={clsx(styles.root, isActive && styles.rootActive, className)}
      {...props}
    >
      {children}
    </button>
  )
);

Tag.displayName = 'Tag';
